import React, { useState } from 'react';
import {
  Typography,
  Stack,
  Button,
  TextField,
  Container,
  Link,
  IconButton,
  InputAdornment,
} from '@mui/material';
import HeroBannerImage from '../assets/images/banner2.jpg';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const [loggedIn, setLoggedIn] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Perform additional logic if needed

      clearForm();
      setLoggedIn(true);
      navigate('/account'); // Navigate to '/account' route
    } catch (error) {
      setError('Invalid email or password');
      console.error('Error logging in: ', error);
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password'); // Navigate to '/forgot-password' route
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  function clearForm() {
    setEmail('');
    setPassword('');
    setError('');
  }

  const handleTrainerLogin = () => {
    navigate('/trainer-login'); // Navigate to '/trainer-login' route
  };

  return (
    <Container maxWidth="md">
      <Stack
        gap="80px"
        sx={{
          flexDirection: { xs: 'column', md: 'row' },
          p: '20px',
          alignItems: 'center',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        <img
          src={HeroBannerImage}
          alt="Exercise Detail"
          loading="lazy"
          className="detail-image"
          style={{ maxWidth: '100%', height: 'auto' , maxHeight:'700px', marginLeft:'-50px'}}
        />
        <Stack
          sx={{
            gap: { xs: '20px', md: '35px' },
            width: '100%',
          }}
        >
          <Typography variant="h3" textAlign="center">
            Login
          </Typography>

          <form onSubmit={handleLogin}>
            <Stack direction="column" gap={3}>
              <TextField
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                type={showPassword ? 'text' : 'password'}
                label="Password"
                variant="outlined"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {error && <Typography color="error">{error}</Typography>}

              <Button variant="contained" type="submit">
                Login
              </Button>
            </Stack>
          </form>

          <Stack direction="column" gap={2} alignItems="center">
            <Typography variant="body2" textTransform="capitalize" color={'black'}>
              <Link href="/register" color={'#000000'}>Don't Have An Account?</Link>
            </Typography>
            <Typography variant="body2" textTransform="capitalize">
              <Link component="button" onClick={handleForgotPassword} color={'#000000'}>
                Forgot Password?
              </Link>
            </Typography>
            <Button variant="contained" onClick={handleTrainerLogin}>
              Trainer Login
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default Login;
